'use client';

import { MenuItem, RadioGroup } from '@headlessui/react';
import { useRouter } from 'next/navigation';
import Dropdown from '@src/components/atoms/dropdown/dropdown';
import RadioWithLabel from '@src/components/atoms/radio';
import {
  SORT_OPTIONS,
  sortLabel,
  sortOption,
  type SortSlug,
} from '@src/lib/seo/proposalSort';

/**
 * Sort, on a hub page — the same `Dropdown` the explorer uses, driven by the
 * URL so the server can apply it to its own slice and the sorted view exists
 * without JavaScript.
 */
export default function HubControls({
  hubPath,
  sort,
  status,
  query,
}: {
  hubPath: string;
  sort: SortSlug;
  status?: string;
  /** Search term to carry through, on the explorer. */
  query?: string;
}) {
  const router = useRouter();

  const hrefFor = (slug: SortSlug) => {
    const params = new URLSearchParams();
    if (query) params.set('q', query);
    if (slug !== 'newest') params.set('sort', slug);
    if (status) params.set('status', status);
    const suffix = params.toString();
    return suffix ? `${hubPath}?${suffix}` : hubPath;
  };

  return (
    <div>
      <div className="flex items-center gap-4">
        <Dropdown
          label={`Sort: ${sortLabel(sort)}`}
          variant="neutral"
          contentWidth={260}
          className="flex justify-center whitespace-nowrap font-medium !text-gray-400"
          menuItems={[
            <MenuItem key="sort title">
              <p className="label12 flex items-center justify-between gap-2 border border-dark-neutral-700 bg-dark-neutral-800 px-4 py-2 font-semibold text-gray-400">
                SORT GOVERNANCE ACTIONS
              </p>
            </MenuItem>,
            <RadioGroup
              key="sorting radio"
              value={sortOption(sort)}
              onChange={(option: { value: SortSlug; label: string }) => {
                router.push(hrefFor(option.value));
              }}
            >
              {SORT_OPTIONS.map((option) => (
                <MenuItem key={option.value}>
                  <RadioWithLabel option={option} className="px-3 py-[15px]" />
                </MenuItem>
              ))}
            </RadioGroup>,
          ]}
        />
      </div>
    </div>
  );
}
